import { RouteConfig } from 'vue-router'
import { LOCALES, toRelative } from './i18n-route'

// Renders nothing of its own - it only hosts the locale segment so every real
// route becomes a child of it.
const PassThrough = {
  render: (h: (tag: string) => unknown) => h('router-view'),
}

// Rewrites one route (and its children) as relative to its parent.
function relativize(route: RouteConfig, parentPath: string): RouteConfig {
  return {
    ...route,
    path: toRelative(route.path, parentPath),
    ...(route.children
      ? { children: route.children.map(c => relativize(c, route.path)) }
      : {}),
  }
}

// Derives the locale-prefixed tree from the flat, absolute route table.
// Order is preserved by construction, so it cannot drift from the source.
// The locale is optional so that a URL without one still matches and reaches
// the normalizing guard instead of throwing or 404-ing.
export function withLangPrefix(routes: RouteConfig[]): RouteConfig[] {
  return [
    {
      path: `/:lang(${LOCALES.join('|')})?`,
      component: PassThrough as never,
      children: routes.map(r => relativize(r, '')),
    },
  ]
}
